// @flow
import styled from 'styled-components'
import { Card } from 'antd'

export const StyledCard = styled(Card) `
  width:100%
  .ant-card-head-title {
    p {
      margin: 0;  
      span { 
        font-size: 10px;
        float: right;            
      } 
    }
   }
`




// WEBPACK FOOTER //
// ./src/components/view-coaching/style.js